export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api/v1"
    : "https://gracious-friendship-production-12f9.up.railway.app/api/v1";
